<template>
  <section class="path-user">
    <div class="layout-container user-activation-page">
      <main role="main" class="main-content-wrapper">
        <div class="container">
          <div class="login-wrapper">
            <div class="alert alert-info alert-custom" key="error">
              <h3 class="info">Your account is not verified</h3>
              <p>Please go to your email and click on the verify link. If you did not recieve an email use the button below to try again.</p>
              <button class="btn btn-info" @click="sendVerificationMail()" v-if="displayButton">Resend verification link</button>
              <div class="alert alert-danger" v-if="alertSentTooManyTimes">
                Verification mail limit reached please contact {{ $store.state.config.supportTel }} for further assistance.
              </div>
              <div class="alert alert-success" v-if="verificationSent">
                Email sent, please check your email. <br />
                <span class="small">Also check your spam email if you do not see it.</span>
              </div>
              <div class="alert" v-if="alreadyVerified">
                Email already verified. Please go to main dashboard page.
                <br />
                <a class="btn btn-info mt-3" href="/">Go to Home</a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </section>
</template>

</template>

<script>
import AuthHeader from '@/components/generic/AuthHeader.vue';

export default {
  components: {
    AuthHeader,
  },
  data() {
    return {
      displayButton: true,
      alertSentTooManyTimes: false,
      verificationSent: false,
      alreadyVerified: false,
    };
  },
  methods: {
    sendVerificationMail() {
      this.$store.commit('setTransLoader', true);
      this.$store
        .dispatch('sentVerificationMail')
        .then((data) => {
          this.displayButton = false;
          if (data.status == 'verification-mail-sent-too-many-times') {
            this.alertSentTooManyTimes = true;
          } else if (data.status == 'verification-link-sent') {
            this.verificationSent = true;
          } else if (data.message == 'Already Verified') {
            this.alreadyVerified = true;
          }
        })
        .finally(() => this.$store.commit('setTransLoader', false));
    },
  },
};
</script>

<style>
</style>